import { i18n } from '@/plugins/i18n';
const { locale } = i18n;

export const CURRENCY = {
  CAD: 'CAD',
  USD: 'USD',
};

export const CURRENCIES = Object.values(CURRENCY);

export const formatNumToCurrency = (number, decimalPlaces = 2) => {
  return toCAD(decimalPlaces).format(number);
};

export const formatCurrencyShort = (number) => {
  if (number === null || number === undefined || isNaN(number)) return '-';
  if (number === 0) return '0M$';

  const abs = Math.abs(number);
  const decimalPlaces = abs < 10000 ? 3 : 2;
  return (number / 1000000).toFixed(decimalPlaces) + 'M$';
};

export const displayCurrency = (number, decimalPlaces = 2) => {
  if (number === null || number === undefined || isNaN(number)) return 'N/A';
  if (number === 0) return '0';
  return formatNumToCurrency(number, decimalPlaces);
};

const toCAD = (dp) =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 0,
    maximumFractionDigits: dp,
  });
